import InputBox from "../common/interactive/InputBox"
import classes from './ForgotPassword.module.css'
import Button from "../common/Button"
import { useDispatch } from "react-redux"
import { notificationActions } from "../../store/notifications"
import { userVerifyOTP } from "../../lib/fetchApi"
import { useState } from "react"

const OtpConfirmation = ({email, action}) => {
    const [isLoading, setIsLoading] = useState(false)


    const dispatch = useDispatch()

    const otpHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)
        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            if (data.new_password !== data.confirm_password) {
                dispatch(notificationActions.setError({errorMessage: 'Passwords do not match!'}))
            } else {
                const verifyOtp = await userVerifyOTP({
                    email: email,
                    otp: data.otp_input,
                    password: data.new_password
                })

                if (verifyOtp?.errorMessage) {
                    dispatch(notificationActions.setError(verifyOtp))
                } else {
                    dispatch(notificationActions.setError({errorMessage: 'success', type: 'success'}))
                    action()
                }
            }
        } finally {
            setIsLoading(false)
        }
    }


    return <>
        <div className={classes.text}>
            <p>Enter the one time token received and set your new password</p>
        </div>
        <form onSubmit={otpHandler}>
            <div className="row">
                <InputBox label="Otp" type="text" name="otp_input" required={true} />
            </div>
            
            <div className="row">
                <InputBox label="New Password" type="password" name="new_password" required={true} placeholder="" icon="ti ti-password-user" passView={true}/>
            </div>
            
            <div className="row">
                <InputBox label="Confirm Password" type="password" name="confirm_password" required={true} icon="ti ti-password-user" passView={true} />
            </div>
            
            <div className={classes.form_footer}>
                <Button type='submit' btnStyle='btn_dark' width={'full'} isLoading={isLoading}>
                    Set New Password
                    <i className='ti ti-chevron-right'></i>
                </Button>
            </div>
        </form>
    </>
}

export default OtpConfirmation